import React, { Component } from "react";

export class TermsOfUseFooter extends Component {
	render() {
		return (
			<div className="terms-of-use-footer">
			    <div className="dx-col terms">
				<span><a href="https://www.privateclientselect.com/termsofuse" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>
<span><a href="https://www.privateclientselect.com/privacynotice" target="_blank" rel="noopener noreferrer">Privacy</a></span>
<span><a href="https://www.privateclientselect.com/legalnotice" target="_blank" rel="noopener noreferrer">Legal Notice</a></span>
			    </div>
			    <div className="dx-col copyright">
				<span> Copyright &copy; 2023 Private Client Select Insurance Services, LLC.</span>
						<span> All rights reserved.  </span>
						<span>
						<a href="https://www.privateclientselect.com/" target="_blank" rel="noopener noreferrer">privateclientselect.com</a>
						</span>
			    </div>
			</div>
		)
	}
};



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/TermsOfUseFooter/TermsOfUseFooter.js